import { useMemo } from 'react';

import type { MenuItem } from '@/consts/navigation';
import { enrichWithBadges } from '@/features/navigation/utils/enrichWithBadges';
import { APPROVALS_ROUTE, hasRoute } from '@/features/navigation/utils/menuRouteUtils';
import { useApprovalsPendingCount } from '@/modules/PMS/features/approvals/hooks/useApprovalsPendingCount';

export const useMenuBadges = (menu: MenuItem[]): MenuItem[] => {
  const hasApprovalsRoute = useMemo(() => hasRoute(menu, APPROVALS_ROUTE), [menu]);
  const { pendingCount } = useApprovalsPendingCount({ enabled: hasApprovalsRoute });

  return useMemo(() => {
    const badgeMap = new Map<string, string>();
    if (pendingCount > 0) {
      badgeMap.set(APPROVALS_ROUTE, String(pendingCount));
    }

    if (badgeMap.size === 0) return menu;

    return enrichWithBadges(menu, badgeMap);
  }, [menu, pendingCount]);
};
